
// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { updateAdmin, fetchAdmins } from "../../redux/actions/AdminActions";
// import {
//   fetchDistricts,
//   fetchMunicipalities,
// } from "../../redux/actions/locationActions";
// import { toast } from "react-hot-toast";

// const EditAdminModal = ({ isOpen, onClose, admin }) => {
//   const dispatch = useDispatch();

//   const { districts, municipalities } = useSelector((state) => state.location);
//   const { token } = useSelector((state) => state.auth);

//   const [formData, setFormData] = useState({
//     id: "",
//     username: "",
//     email: "",
//     phone: "",
//     district_id: "",
//     municipality_id: "",
//   });

//   // Fetch districts and municipalities only once
//   useEffect(() => {
//     if (isOpen) {
//       dispatch(fetchDistricts());
//       dispatch(fetchMunicipalities());
//     }
//   }, [dispatch, isOpen]);

//   // Update form once all data is available
//   useEffect(() => {
//     if (admin && districts.length && municipalities.length) {
//       const matchedDistrict = districts.find((d) => d.name === admin.district);
//       const matchedMunicipality = municipalities.find((m) => m.name === admin.municipality);

//       setFormData({
//         id: admin.id || "",
//         username: admin.username || "",
//         email: admin.email || "",
//         phone: admin.phone || "",
//         district_id: admin.district_id || matchedDistrict?.id || "",
//         municipality_id: admin.municipality_id || matchedMunicipality?.id || "",
//       });
//     }
//   }, [admin, districts, municipalities]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     dispatch(
//       updateAdmin(formData, token, () => {
//         toast.success("Admin updated successfully!");
//         dispatch(fetchAdmins(token)); // Refresh list
//         onClose(); // Close modal
//       })
//     );
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
//       <div className="bg-white p-6 rounded shadow-md w-full max-w-md">
//         <h2 className="text-xl font-bold mb-4">Edit Admin</h2>
//         <form onSubmit={handleSubmit} className="space-y-4">
//           <input
//             type="text"
//             name="username"
//             value={formData.username}
//             onChange={handleChange}
//             placeholder="Username"
//             className="w-full border p-2 rounded"
//             required
//           />
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             placeholder="Email"
//             className="w-full border p-2 rounded"
//             required
//           />
//           <input
//             type="text"
//             name="phone"
//             value={formData.phone}
//             onChange={handleChange}
//             placeholder="Phone"
//             className="w-full border p-2 rounded"
//             required
//           />
//           <select
//             name="district_id"
//             value={formData.district_id}
//             onChange={handleChange}
//             className="w-full border p-2 rounded"
//             required
//           >
//             <option value="">Select District</option>
//             {districts.map((d) => (
//               <option key={d.id} value={d.id}>
//                 {d.name}
//               </option>
//             ))}
//           </select>
//           <select
//             name="municipality_id"
//             value={formData.municipality_id}
//             onChange={handleChange}
//             className="w-full border p-2 rounded"
//             required
//           >
//             <option value="">Select Municipality</option>
//             {municipalities.map((m) => (
//               <option key={m.id} value={m.id}>
//                 {m.name}
//               </option>
//             ))}
//           </select>
//           <div className="flex justify-end gap-2">
//             <button
//               type="button"
//               onClick={onClose}
//               className="px-4 py-2 bg-gray-400 text-white rounded"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="px-4 py-2 bg-blue-600 text-white rounded"
//             >
//               Update
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditAdminModal;


import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateAdmin, fetchAdmins,fetchProgrammes } from "../../redux/actions/AdminActions";
import {
  fetchDistricts,
  fetchMunicipalities, // ✅ Import your new action
} from "../../redux/actions/locationActions";
import { toast } from "react-hot-toast";

const EditAdminModal = ({ isOpen, onClose, admin }) => {
  const dispatch = useDispatch();

  const { districts, municipalities } = useSelector((state) => state.location); // ✅ Added programmes
  const { token } = useSelector((state) => state.auth);
  const { programmes = [] } = useSelector((state) => state.admin); // ✅ fixed

  const [formData, setFormData] = useState({
    id: "",
    username: "",
    email: "",
    phone: "",
    district_id: "",
    municipality_id: "",
    programme_id: "", // ✅ Added programme_id
  });

  // Fetch all dropdown data when modal opens
  useEffect(() => {
    if (isOpen) {
      dispatch(fetchDistricts());
      dispatch(fetchMunicipalities());
      dispatch(fetchProgrammes()); // ✅ Fetch programmes
    }
  }, [dispatch, isOpen]);

  // Update form once all data is available
  useEffect(() => {
    if (admin && districts.length && municipalities.length && programmes.length) {
      const matchedDistrict = districts.find((d) => d.name === admin.district);
      const matchedMunicipality = municipalities.find((m) => m.name === admin.municipality);
      const matchedProgramme = programmes.find((p) => p.name === admin.programme); // ✅ Match by name

      setFormData({
        id: admin.id || "",
        username: admin.username || "",
        email: admin.email || "",
        phone: admin.phone || "",
        district_id: admin.district_id || matchedDistrict?.id || "",
        municipality_id: admin.municipality_id || matchedMunicipality?.id || "",
        programme_id: admin.programme_id || matchedProgramme?.id || "", // ✅ Set programme_id
      });
    }
  }, [admin, districts, municipalities, programmes]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      updateAdmin(formData, token, () => {
        toast.success("Admin updated successfully!");
        dispatch(fetchAdmins(token)); // Refresh list
        onClose(); // Close modal
      })
    );
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Edit Admin</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Username */}
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            placeholder="Username"
            className="w-full border p-2 rounded"
            required
          />
          {/* Email */}
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            className="w-full border p-2 rounded"
            required
          />
          {/* Phone */}
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone"
            className="w-full border p-2 rounded"
            required
          />
          {/* District */}
          <select
            name="district_id"
            value={formData.district_id}
            onChange={handleChange}
            className="w-full border p-2 rounded"
           
          >
            <option value="">Select District</option>
            {districts.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>
          {/* Municipality */}
          <select
            name="municipality_id"
            value={formData.municipality_id}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            
          >
            <option value="">Select Municipality</option>
            {municipalities.map((m) => (
              <option key={m.id} value={m.id}>
                {m.name}
              </option>
            ))}
          </select>
          {/* Programme */}
          <select
            name="programme_id"
            value={formData.programme_id}
            onChange={handleChange}
            className="w-full border p-2 rounded"
            required
          >
            <option value="">Select Programme</option>
            {programmes.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
          {/* Buttons */}
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-400 text-white rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAdminModal;
